"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var angular = require("angular");
var main_component_1 = require("./main.component");
function routeConfig($stateProvider) {
    "ngInject";
    $stateProvider
        .state("app.main", {
        url: "/",
        component: "main"
    });
}
function runConfig(NavService) {
    var page = {
        state: "app.main",
        url: "/",
        label: "Восстановление",
        icon: "thumb_up"
    };
    NavService.addNavItem(page);
}
var Main = angular
    .module("components.main", [
    "blockUI",
    "mdCollectionPagination"
])
    .component("main", new main_component_1.MainComponent)
    .config(routeConfig)
    .run(runConfig);
exports.default = Main;



/** WEBPACK FOOTER **
 ** ./src/app/components/main/index.ts
 **/